import {appUrl} from '@frontend/AppUrl'
import ErrorPage from '@frontend/modules/public/errors/ErrorPage'
import {
    Component,
    type ReactNode,
} from 'react'
import {AppConfig} from '../AppConfig'

interface Props {
    children: ReactNode | ReactNode[]
    silent?: boolean
    inline?: boolean
    noLogo?: boolean
}

interface State {
    hasError: boolean
}

/*
 * Ограничитель глубины отрабатывания ошибок в JS/JSX.
 * Если ошибка произошла внутри этого компонента, то отображается страница с ошибкой.
 * Ошибка так же не будет влиять на всё приложение
 * (т.е. интерфейс вне компонента продолжит работать вместо полного отказа).
 */
export class ErrorBoundary extends Component<Props, State> {

    state: State = {
        hasError: false,
    }

    static getDerivedStateFromError() {
        return {hasError: true}
    }

    componentDidCatch(error: Error) {
        console.error('[ErrorBoundary] Error caught: ', error)
        /*
         * todo: Раскомментировать если будем использовать Sentry
         * componentDidCatch(error: Error, errorInfo: ErrorInfo) {
         * if (AppConfig.isProduction) {
         *     Sentry.captureException(error, {
         *         extra: {
         *             componentStack: errorInfo.componentStack,
         *         },
         *     })
         * }
         */
    }

    render() {
        if (this.state.hasError) {
            if (this.props.silent && AppConfig.isProduction) {
                return null
            }
            return (
                <ErrorPage
                    code="js"
                    preferHistoryBack={true}
                    backUrl={appUrl().index}
                    inline={this.props.inline}
                    noLogo={this.props.noLogo}
                />
            )
        }

        return this.props.children
    }
}
